<template>
  <div>
    <div v-if="currentStepIndex >= 0" class="nav-steps">
      <masthead
        :image-url="getMasthead()"
        mast-head-type="default"
        class="nav-steps__masthead"
      />
      <div
        class="nav-steps__progress"
        :class="{
          suspended: isSuspended(),
        }"
      >
        <el-steps :active="currentStepIndex" align-center>
          <template v-for="(step, index) in stepsData()">
            <el-step
              v-if="
                step.routeName !== 'completed' &&
                step.routeName !== 'checkin-suspended'
              "
              :key="index"
              :class="{
                completed: isCompleted() && index === currentStepIndex - 1,
              }"
              :title="getStepTitle(index)"
            >
            </el-step>
          </template>
        </el-steps>
      </div>
      <div v-if="!isSuspended()" class="nav-steps__header container">
        <div
          class="nav-steps__number"
          v-if="currentStepIndex + 1 !== stepsData().length - 1"
        >
          Step {{ currentStepIndex + 1 }} of {{ stepsData().length - 2 }}
        </div>
        <div class="nav-steps__number" v-else>SUCCESS</div>
        <h1 class="nav-steps__title">
          {{ stepsData()[currentStepIndex].title }}
        </h1>
        <div
          v-if="stepsData()[currentStepIndex].subtitle"
          class="nav-steps__subtitle"
        >
          {{ stepsData()[currentStepIndex].subtitle }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import contactMixin from "../mixins/contact";
import Masthead from "./ui/Masthead.vue";
import { mapGetters } from "vuex";
import types from "../store/types";
import { NAV_STEPS } from "../constants";

export default {
  components: {
    Masthead,
  },
  mixins: [contactMixin],
  data() {
    return {
      // stepsData,
      currentStepIndex: -1,
    };
  },
  mounted() {
    this.currentStepIndex = this.stepsData().findIndex(
      (step) => step.routeName === this.$route.name,
    );
  },
  computed: {
    ...mapGetters([types.getters.booking]),
    currentNavStep() {
      return (
        this.stepsData()[this.currentStepIndex].navStep || NAV_STEPS.Incomplete
      );
    },
  },
  watch: {
    "$route.name": function (routeName) {
      this.currentStepIndex = this.stepsData().findIndex(
        (step) => step.routeName === routeName,
      );
    },
  },
  methods: {
    getMasthead() {
      switch (this.currentNavStep) {
        case NAV_STEPS.BookingSummary:
          return `https://d20knvk822eu5a.cloudfront.net/s3fs-public-optimized/static-assets/online-check-in/mastheads/cropped/masthead-step1-${this.booking.facilityCode}_v2.jpg.webp`;
        case NAV_STEPS.PersonalDetails:
          return `https://d20knvk822eu5a.cloudfront.net/s3fs-public-optimized/static-assets/online-check-in/mastheads/cropped/masthead-step2-${this.booking.facilityCode}.jpg.webp`;
        case NAV_STEPS.DietaryPreferences:
          return `https://d20knvk822eu5a.cloudfront.net/s3fs-public-optimized/static-assets/online-check-in/mastheads/cropped/masthead-step3-${this.booking.facilityCode}.jpg.webp`;
        case NAV_STEPS.WetsuitDiving:
          return `https://d20knvk822eu5a.cloudfront.net/s3fs-public-optimized/static-assets/online-check-in/mastheads/cropped/masthead-step4-${this.booking.facilityCode}.jpg.webp`;
        case NAV_STEPS.PrePostCruise:
          return `https://d20knvk822eu5a.cloudfront.net/s3fs-public-optimized/static-assets/online-check-in/mastheads/cropped/masthead-step5-${this.booking.facilityCode}.jpg.webp`;
        case NAV_STEPS.Confirmation:
          return `https://d20knvk822eu5a.cloudfront.net/s3fs-public-optimized/static-assets/online-check-in/mastheads/cropped/masthead-step6-${this.booking.facilityCode}.jpg.webp`;
        case NAV_STEPS.Success:
          return `https://d20knvk822eu5a.cloudfront.net/s3fs-public-optimized/static-assets/online-check-in/mastheads/cropped/masthead-success-${this.booking.facilityCode}.jpg.webp`;
        case NAV_STEPS.Incomplete:
          return `https://d20knvk822eu5a.cloudfront.net/s3fs-public-optimized/static-assets/online-check-in/mastheads/cropped/masthead-incomplete-${this.booking.facilityCode}.jpg.webp`;
        default:
          return `https://d20knvk822eu5a.cloudfront.net/s3fs-public-optimized/static-assets/online-check-in/mastheads/cropped/masthead-incomplete-${this.booking.facilityCode}.jpg.webp`;
      }
    },
    getStepTitle(stepIndex) {
      const stepsData = this.stepsData();
      if (stepIndex === stepsData.length - 1) {
        return this.currentStepIndex === 5 ? "Completed" : "Confirmation";
      }
      return stepsData[stepIndex].stepTitle;
    },
    stepsData() {
      let steps = [
        {
          routeName: "step-1",
          title: "Booking Summary",
          stepTitle: "Summary",
          navStep: NAV_STEPS.BookingSummary,
        },
        {
          routeName: "step-2",
          title: "Personal details",
          stepTitle: "Personal details",
          navStep: NAV_STEPS.PersonalDetails,
        },
        {
          routeName: "step-3",
          title: "Dietary and special requests",
          stepTitle: "Dietary and special requests",
          navStep: NAV_STEPS.DietaryPreferences,
        },
        ...(this.hasDiving()
          ? [
              {
                routeName: "step-3b",
                title: "Diving option",
                stepTitle: "Diving option",
                navStep: NAV_STEPS.WetsuitDiving,
              },
            ]
          : []),
        ...(this.hasWetsuit()
          ? [
              {
                routeName: "step-3c",
                title: "Wetsuit option",
                stepTitle: "Wetsuit option",
                navStep: NAV_STEPS.WetsuitDiving,
              },
            ]
          : []),
        {
          routeName: "step-4",
          title: "Your Pre and Post-cruise information",
          subtitle:
            "Your input will help us better coordinate your arrival & departure arrangements.",
          stepTitle: "Pre and Post-cruise information",
          navStep: NAV_STEPS.PrePostCruise,
        },
        {
          routeName: "step-5",
          title: "Confirm your details",
          stepTitle: "Confirmation",
          navStep: NAV_STEPS.Confirmation,
        },
        {
          routeName: "completed",
          title: "Thank you for completing \n" + "the online check-in process",
          stepTitle: "Completed",
          navStep: NAV_STEPS.Success,
        },
        {
          routeName: "checkin-suspended",
          title: "",
          stepTitle: "Check in suspended",
          navStep: NAV_STEPS.Incomplete,
        },
      ];
      return steps;
    },
    isCompleted() {
      return this.stepsData()[this.currentStepIndex].routeName === "completed";
    },
    isSuspended() {
      return (
        this.currentStepIndex === -1 ||
        this.stepsData()[this.currentStepIndex].routeName ===
          "checkin-suspended"
      );
    },
  },
};
</script>

<style lang="scss">
@import "../scss/color";
@import "../scss/typography";

.nav-steps {
  position: relative;
  &__masthead {
    height: 100%;
  }

  &__progress {
    position: absolute;
    top: 40vh;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 999;
    width: 1280px; // TODO: update this width
  }

  &__header {
    padding-top: 80px;
    padding-bottom: 48px;
  }

  &__number {
    margin-bottom: 16px;
    @include small-regular-search-label;
    text-align: center;
    color: $aqua-grey-50;
  }

  &__title {
    margin-bottom: 0;
    @include desktop-title-title2;
    text-align: center;
    color: $aqua-grey-100;
  }

  &__subtitle {
    margin-top: 4px;
    text-align: center;
    @include global-paragraph-medium-regular;
    color: $aqua-grey-100;
  }

  //.el-step__title.is-process {
  //  font-size: 13px; // IE hack to fit the text
  //}

  .completed {
    .el-step__icon {
      background-color: #87b46c;

      &-inner {
        color: $white-100;
      }
    }

    .el-step__title {
      font-weight: bold;
    }
  }

  .suspended {
    bottom: 0px;

    .el-step__icon,
    .el-step__line {
      background-color: $white-25;
      color: $white-50;

      &-inner {
        border: unset;
      }
    }

    .el-step__icon-inner,
    .el-step__title {
      color: $white-50;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavSteps.vue